import { render, staticRenderFns } from "./Guardian.vue?vue&type=template&id=1062d1ce&scoped=true&"
import script from "./Guardian.vue?vue&type=script&lang=js&"
export * from "./Guardian.vue?vue&type=script&lang=js&"
import style0 from "./Guardian.vue?vue&type=style&index=0&id=1062d1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1062d1ce",
  null
  
)

export default component.exports